// extracted by mini-css-extract-plugin
export var actionText = "_ka-4";
export var container = "_ka-0";
export var leftSection = "_ka-1";
export var rightSection = "_ka-2";
export var settingsButton = "_ka-6";
export var settingsIcon = "_ka-7";
export var shortcut = "_ka-5";
export var shortcutGroup = "_ka-3";